import audioManager, { s_auraMenu } from "./Sounds";
import InventoryItem from "./InventoryItem.js";
import GloveIcon from "./Icons/GloveIcon.js";
import RingIcon from "./Icons/RingIcon.js";
import NecklaceIcon from "./Icons/NecklaceIcon.js";
import HelmetIcon from "./Icons/HelmetIcon.js";
import { useState } from "react";

const ItemsInventory = ({
  t,
  motion,
  items,
  activeItemDetails,
  setActiveItem,
  ring,
  glove,
  helmet,
  necklace,
  filterItemsByType,
}) => {
  return (
    <>
      <div className="inventory-title">
        <div className="invenory-title-text">{t("Inventory")}</div>
        <div className="dropdown-container">
          <select
            className="dropdown"
            onChange={(e) => filterItemsByType(e.target.value)}
          >
            <option value="all">{t("ALL")}</option>
            <option value="potion">{t("POTIONS")}</option>
            <option value="ring">{t("RINGS")}</option>
            <option value="glove">{t("GLOVES")}</option>
            <option value="necklace">{t("NECKLACES")}</option>
            <option value="helmet">{t("HELMETS")}</option>

            {/* Добавь другие типы, если нужно */}
          </select>
        </div>
      </div>
      <motion.div
        initial={{ y: 25, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        className="inventory-container add-ui-container"
      >
        {items?.length > 0 && (
          <div className="inventory-table">
            {items.map((item, index) => (
              <InventoryItem
                t={t}
                key={item?.title || index}
                item={item}
                onClick={() => {
                  audioManager.play("s_auraMenu");
                  activeItemDetails(items[index], items[index].quantity);
                }}
              />
            ))}
          </div>
        )}
        {items?.length === 0 && (
          <div style={{ textAlign: "center", padding: "30px 10px" }}>
            {t("empty")}
          </div>
        )}
      </motion.div>

      <div className="inventory-container equipped-items-container">
        <div className="wearing-text"> {t("wearing")}:</div>
        <div style={{ display: "flex", gap: 5 }}>
          <motion.div
            whileTap={{ scale: 0.95 }}
            className="equipped-item"
            style={{ backgroundImage: ring ? `url(${ring.miniimg})` : "" }}
            onClick={() => {
              audioManager.play("s_auraMenu");
              if (ring) {
                setActiveItem(ring);
              }
            }}
          >
            <RingIcon size={24}></RingIcon>
          </motion.div>
          <motion.div
            whileTap={{ scale: 0.95 }}
            className="equipped-item"
            style={{ backgroundImage: glove ? `url(${glove.miniimg})` : "" }}
            onClick={() => {
              audioManager.play("s_auraMenu");
              if (glove) {
                setActiveItem(glove);
              }
            }}
          >
            <GloveIcon size={24}></GloveIcon>
          </motion.div>
          <motion.div
            whileTap={{ scale: 0.95 }}
            className="equipped-item"
            style={{
              backgroundImage: necklace ? `url(${necklace.miniimg})` : "",
            }}
            onClick={() => {
              audioManager.play("s_auraMenu");
              if (necklace) {
                setActiveItem(necklace);
              }
            }}
          >
            <NecklaceIcon size={24}></NecklaceIcon>
          </motion.div>
          <motion.div
            whileTap={{ scale: 0.95 }}
            className="equipped-item"
            style={{ backgroundImage: helmet ? `url(${helmet.miniimg})` : "" }}
            onClick={() => {
              audioManager.play("s_auraMenu");
              if (helmet) {
                setActiveItem(helmet);
              }
            }}
          >
            <HelmetIcon size={24}></HelmetIcon>
          </motion.div>
        </div>
      </div>
    </>
  );
};
export default ItemsInventory;
